import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.id) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome, ${res.user.name}`);
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center px-5 py-12" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-display text-3xl text-charcoal">Weddings by Mostash</div>
          <div className="mt-2 uppercase tracking-[0.3em] text-[10px] text-charcoal/50">Admin</div>
        </div>
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-white border border-beige p-8 md:p-10"
        >
          <div className="flex items-center gap-2 text-teal-600 mb-6">
            <Lock className="h-4 w-4" strokeWidth={1.5} />
            <span className="uppercase tracking-[0.25em] text-[11px] font-medium">Sign in</span>
          </div>
          <label className="block">
            <span className="uppercase tracking-[0.25em] text-[10px] text-charcoal/50">Email</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-3 field-input"
            />
          </label>
          <label className="block mt-6">
            <span className="uppercase tracking-[0.25em] text-[10px] text-charcoal/50">Password</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-3 field-input"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-10 w-full btn-primary disabled:opacity-60"
          >
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" />Signing in</> : "Sign in"}
          </button>
          <a href="/" className="block text-center mt-6 text-[11px] uppercase tracking-[0.25em] text-charcoal/40 hover:text-teal-600">
            ← Back to site
          </a>
        </form>
      </div>
    </div>
  );
}
